import React from 'react';

import {useMonsterQuery} from '../../generated/types';
import {OtherTitles} from '../other-titles';
import {getSourceText} from '../utils';
import {MonsterStatblock} from './monster-statblock';

import markdownCss from '../utils/md/markdown.module.css';
import css from './monster-view.module.css';

type Props = {
	monsterId: string;
};

export const MonsterView: React.FC<Props> = ({monsterId}) => {
	const {data} = useMonsterQuery({variables: {id: monsterId}});
	const monster = data?.monster;
	if (!monster) return null;

	return (
		<MonsterStatblock
			monster={monster}
			aside={
				<div className={css.tokenWrapper}>
					{monster.token && (
						<div className={css.token}>
							<img src={`/images/${monster.token.path}`} alt="" />
						</div>
					)}
				</div>
			}
			footer={
				<div className={markdownCss.margin}>
					<div className={markdownCss.indent}>
						<OtherTitles
							originalTitle={monster.originalTitle}
							alternativeTitles={monster.alternativeTitles}
						/>
						<p>
							<b>Источник: </b>
							{getSourceText(monster.source as any)}.
						</p>
					</div>
				</div>
			}
		/>
	);
};
